import { render, staticRenderFns } from "./SetFontSize.vue?vue&type=template&id=6e570136"
import script from "./SetFontSize.vue?vue&type=script&lang=js"
export * from "./SetFontSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports